// Supabase sync configuration — the sole cloud sync config (D42: Firebase removed).

export type SupabaseSyncConfigStatus = {
  enabled: boolean;
  missingKeys: string[];
  requested: boolean;
};

type SupabaseSyncEnv = Partial<
  Record<"VITE_SYNC_MODE" | "VITE_SUPABASE_URL" | "VITE_SUPABASE_ANON_KEY", string | boolean | undefined>
>;

const REQUIRED_KEYS = ["VITE_SUPABASE_URL", "VITE_SUPABASE_ANON_KEY"] as const;

export function supabaseSyncEnabled(): boolean {
  return supabaseSyncConfigStatus().enabled;
}

export function supabaseSyncConfigStatus(): SupabaseSyncConfigStatus {
  return resolveSupabaseSyncConfig(import.meta.env);
}

export function resolveSupabaseSyncConfig(env: SupabaseSyncEnv): SupabaseSyncConfigStatus {
  const requested = env.VITE_SYNC_MODE === "supabase";
  const missingKeys = requested ? REQUIRED_KEYS.filter((key) => !env[key]) : [];
  return {
    enabled: requested && missingKeys.length === 0,
    missingKeys,
    requested,
  };
}
